import type { DatentransformationDebugSettings } from '@core/domain';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from '@/features/auth/AuthProvider';
import { queryKeys } from './queryKeys';
import { useApiClient } from './useApiClient';

export const useDatentransformationDebugSettings = () => {
  const { eventDokumentTypMappingsApi } = useApiClient();
  return useQuery<DatentransformationDebugSettings>({
    queryKey: queryKeys.konfiguration.datentransformationDebugSettings(),
    queryFn: async () =>
      (await eventDokumentTypMappingsApi.getDatentransformationDebugSettings())
        .data,
  });
};

export const useUpdateDatentransformationDebugSettings = () => {
  const { eventDokumentTypMappingsApi } = useApiClient();
  const queryClient = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (settings: DatentransformationDebugSettings) =>
      (
        await eventDokumentTypMappingsApi.updateDatentransformationDebugSettings(
          {
            user: user?.email || '',
            getDatentransformationDebugSettings200Response: settings,
          },
        )
      ).data,
    onSuccess: (settings) => {
      queryClient.setQueryData(
        queryKeys.konfiguration.datentransformationDebugSettings(),
        settings,
      );
      toast.success('Debug-Einstellungen wurden gespeichert.');
    },
  });
};
